// FeeSelectorModal.jsx
import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CREDIT_FEE_TABLE = {
  visa: [
    { installments: 1, rate: 3.74 },
    { installments: 2, rate: 4.86 },
    { installments: 3, rate: 5.68 },
    { installments: 4, rate: 6.50 },
    { installments: 5, rate: 7.32 },
    { installments: 6, rate: 8.14 },
    { installments: 7, rate: 9.33 },
    { installments: 8, rate: 10.15 },
    { installments: 9, rate: 10.96 },
    { installments: 10, rate: 11.78 },
    { installments: 11, rate: 12.60 },
    { installments: 12, rate: 13.41 },
    { installments: 13, rate: 14.23 },
    { installments: 14, rate: 15.05 },
    { installments: 15, rate: 15.86 },
    { installments: 16, rate: 16.68 },
    { installments: 17, rate: 17.50 },
    { installments: 18, rate: 18.31 },
  ],

  mastercard: [
    { installments: 1, rate: 3.74 },
    { installments: 2, rate: 4.86 },
    { installments: 3, rate: 5.68 },
    { installments: 4, rate: 6.50 },
    { installments: 5, rate: 7.32 },
    { installments: 6, rate: 8.14 },
    { installments: 7, rate: 9.33 },
    { installments: 8, rate: 10.15 },
    { installments: 9, rate: 10.96 },
    { installments: 10, rate: 11.78 },
    { installments: 11, rate: 12.60 },
    { installments: 12, rate: 13.41 },
    { installments: 13, rate: 14.23 },
    { installments: 14, rate: 15.05 },
    { installments: 15, rate: 15.86 },
    { installments: 16, rate: 16.68 },
    { installments: 17, rate: 17.50 },
    { installments: 18, rate: 18.31 },
  ],

  elo: [
    { installments: 1, rate: 4.19 },
    { installments: 2, rate: 5.54 },
    { installments: 3, rate: 6.36 },
    { installments: 4, rate: 7.17 },
    { installments: 5, rate: 7.98 },
    { installments: 6, rate: 8.80 },
    { installments: 7, rate: 10.14 },
    { installments: 8, rate: 10.95 },
    { installments: 9, rate: 11.76 },
    { installments: 10, rate: 12.57 },
    { installments: 11, rate: 13.38 },
    { installments: 12, rate: 14.19 },
    { installments: 13, rate: 15.00 },
    { installments: 14, rate: 15.81 },
    { installments: 15, rate: 16.62 },
    { installments: 16, rate: 17.43 },
    { installments: 17, rate: 18.24 },
    { installments: 18, rate: 19.04 },
  ],

  americanExpress: [
    { installments: 1, rate: 4.56 },
    { installments: 2, rate: 5.48 },
    { installments: 3, rate: 6.30 },
    { installments: 4, rate: 7.11 },
    { installments: 5, rate: 7.93 },
    { installments: 6, rate: 8.74 },
    { installments: 7, rate: 9.67 },
    { installments: 8, rate: 10.48 },
    { installments: 9, rate: 11.29 },
    { installments: 10, rate: 12.11 },
    { installments: 11, rate: 12.92 },
    { installments: 12, rate: 13.73 },
    { installments: 13, rate: 14.55 },
    { installments: 14, rate: 15.36 },
    { installments: 15, rate: 16.18 },
    { installments: 16, rate: 16.99 },
    { installments: 17, rate: 17.80 },
    { installments: 18, rate: 18.62 },
  ],
};


// Tabela para débito - taxa única por bandeira
const DEBIT_FEE_TABLE = {
  elo: 1.40,
  //hipercard: 2.29,
  mastercard: 0.99,
  visa: 0.99,
  americanExpress: 0,
  //cabal: 5.0,
  //unionPay: 4.0,
};

// Função helper para buscar a taxa de crédito
function getCreditFee(brand, installments) {
  const brandRates = CREDIT_FEE_TABLE[brand];
  if (!brandRates) return 0;

  const rateConfig = brandRates.find(
    config => config.installments === installments
  );

  return rateConfig?.rate ?? 0;
}

// Função helper para buscar a taxa de débito
function getDebitFee(brand) {
  return DEBIT_FEE_TABLE[brand] ?? 0;
}

export default function FeeSelectorModal({
  show,
  method,
  onHide,
  initialBrand,
  initialInstallments,
  onConfirm,
}) {
  const [brand, setBrand] = useState(initialBrand || "");
  const [installments, setInstallments] = useState(initialInstallments || 1);

  // Se o parent trocar as props de inicialização, reflita aqui:
  useEffect(() => {
    setBrand(initialBrand || "");
    setInstallments(initialInstallments || 1);
  }, [initialBrand, initialInstallments]);

  const tax = brand 
    ? method === 'credit' 
      ? getCreditFee(brand, installments)
      : getDebitFee(brand)
    : 0;
  
  // Esconde seletor de parcelas se for débito
  const showInstallments = method === 'credit';

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Escolher bandeira e parcelas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Bandeira</Form.Label>
          <Form.Select value={brand} onChange={(e) => setBrand(e.target.value)}>
            <option value="" disabled>
              -- selecione --
            </option>
            <option value="visa">Visa</option>
            <option value="mastercard">Mastercard</option>
            <option value="americanExpress">American Express</option>
            <option value="elo">Elo</option>
          </Form.Select>
        </Form.Group>

        {showInstallments && (
          <Form.Group className="mt-3">
            <Form.Label>Parcelas</Form.Label>
            <Form.Select
              value={installments}
              onChange={(e) => setInstallments(Number(e.target.value))}>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map((n) => (
                <option key={n} value={n}>
                  {n}x
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {brand && (
          <div className="mt-3">
            <strong>Taxa aplicada: {tax}%</strong>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={() => onConfirm({ brand, installments: showInstallments ? installments : 1, tax })}
          disabled={!brand}>
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
